import auth from "./auth";
import appInfo from "./app-info";
import { createRouter, createWebHashHistory } from "vue-router";

// import Home from "./views/home-page";
import HomePageLandingOnly from "./views/home-page-landingonly";
import Profile from "./views/profile-page";
import CompanyProfile from "./views/company-profile";
import ManageEmployees from "./views/manage-employees";
import ManageResults from "./views/manage-results";
import JobOfferSearch from "./views/joboffer-search";
import GeneralSurvey from "./views/general-survey";
import NnrcSurvey from "./views/nnrc-survey";
import MindwebSurvey from "./views/mindweb-survey";
import CustomSurvey from "./views/custom-survey";
import DataDashboard from "./views/data-dashboard";
import PlatformDashboard from "./views/platform-dashboard";
import RaffleList from "./views/raffle-list";
import RaffleRun from "./views/raffle-run";
import Big5Demo from "./views/big5-demo";
import defaultLayout from "./layouts/side-nav-outer-toolbar";
import defaultLayoutFocus from "./layouts/side-nav-outer-toolbar-focus";
import simpleLayout from "./layouts/single-card";

function loadView(view) {
	return () => import (/* webpackChunkName: "login" */ `./views/${view}.vue`)
}

// Some routes are conditional on site mode.
let isColpuno = appInfo.siteMode == 'colpuno';

const router = new createRouter({
	routes: [
		{
			path: "/home",
			name: "home",
			meta: {
				// requiresAuth: true,
				layout: defaultLayout
			},
			// component: Home
			component: HomePageLandingOnly,
		},
		{
			path: "/profile",
			name: "profile",
			meta: {
				requiresAuth: true,
				layout: defaultLayout
			},
			component: Profile
		},
		{
			path: "/survey/general",
			name: "survey_general",
			meta: {
				requiresAuth: false,
				disabled: !isColpuno,
				layout: defaultLayout
			},
			component: GeneralSurvey
		},
		{
			path: "/survey/nnrc",
			name: "survey_nnrc",
			meta: {
				requiresAuth: false,
				disabled: !isColpuno,
				layout: defaultLayout
			},
			component: NnrcSurvey
		},
		{
			path: "/survey/mindweb",
			name: "survey_mindweb",
			meta: {
				requiresAuth: false,
				disabled: !isColpuno,
				layout: defaultLayout
			},
			component: MindwebSurvey
		},
		{
			path: "/survey/:surveyType",
			name: "survey_custom",
			meta: {
				requiresAuth: false,
				layout: defaultLayoutFocus
			},
			component: CustomSurvey
		},
		{
			path: "/aatrium",
			redirect: "/survey/aatrium"
		},
		{
			path: "/dashboard/data",
			name: "data_dashboard",
			meta: {
				requiresAuth: true,
				disabled: !isColpuno,
				layout: defaultLayout
			},
			component: DataDashboard
		},
		{
			path: "/dashboard/platform",
			name: "platform_dashboard",
			meta: {
				requiresAuth: true,
				disabled: !isColpuno,
				layout: defaultLayout
			},
			component: PlatformDashboard
		},
		{
			path: "/company/:id",
			name: "company",
			meta: {
				requiresAuth: true,
				disabled: !isColpuno,
				layout: defaultLayout,
				backdrop: 'profile-backdrop'
			},
			component: CompanyProfile
		},
		{
			path: "/joboffer",
			name: "joboffer_search",
			meta: {
				requiresAuth: true,
				disabled: !isColpuno,
				layout: defaultLayout
			},
			component: JobOfferSearch
		},
		{
			path: "/manage",
			redirect: "/manage/employees"
		},
		{
			path: "/manage/employees",
			name: "manage_employees",
			meta: {
				requiresAuth: true,
				layout: defaultLayout
			},
			component: ManageEmployees
		},
		{
			path: "/manage/results",
			name: "manage_results",
			meta: {
				requiresAuth: true,
				layout: defaultLayout
			},
			component: ManageResults
		},
		{
			path: "/raffle",
			name: "raffle",
			meta: {
				requiresAuth: true,
				layout: defaultLayout
			},
			component: RaffleList
		},
		{
			path: "/raffle/:raffleType",
			name: "raffle_run",
			meta: {
				requiresAuth: true,
				layout: defaultLayoutFocus
			},
			component: RaffleRun
		},
		{
			path: "/big5",
			name: "big5_demo",
			meta: {
				requiresAuth: false,
				layout: defaultLayoutFocus
			},
			component: Big5Demo
		},
		{
			path: "/login-form",
			name: "login-form",
			meta: {
				requiresAuth: false,
				layout: simpleLayout,
				title: "Sign in / Register",
			},
			component: loadView("login-form")
		},
		{
			path: "/reset-password",
			name: "reset-password",
			meta: {
				// requiresAuth: false,
				requiresAuth: true,
				layout: simpleLayout,
				title: "Reset Password",
				description: "Please enter the email address that you used to register, and we will send you a link to reset your password via Email."
			},
			component: loadView("reset-password-form")
		},
		{
			path: "/change-password/:recoveryCode",
			name: "change-password",
			meta: {
				// requiresAuth: false,
				requiresAuth: true,
				layout: simpleLayout,
				title: "Change Password"
			},
			component: loadView("change-password-form")
		},
		{
			path: "/",
			redirect: "/home"
		},
		{
			path: "/recovery",
			redirect: "/home"
		},
		{
			path: "/:pathMatch(.*)*",
			redirect: "/home"
		}
	],
	history: createWebHashHistory()
});

router.beforeEach((to, from, next) => {

	if (to.name === "login-form" && auth.loggedIn()) {
		next({ name: "home" });
	}
	if (to.matched.some(record => record.meta.disabled)) {
		next({ name: "home" });
	}

	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (!auth.loggedIn()) {
			next({
				name: "login-form",
				query: { redirect: to.fullPath }
			});
		} else {
			next();
		}
	} else {
		next();
	}
});

export default router;
